import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useConnectedApps(businessId: string | undefined) {
  const trpc = useTRPC();
  return useQuery(
    trpc.apps.getConnectedApps.queryOptions(
      { businessId: businessId ?? "" },
      { enabled: Boolean(businessId) },
    ),
  );
}
